import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from './../file-upload/file-upload.component';
import { SwitchControlComponent } from './../common/switch-control/switch-control.component';
import { TextInputControlComponent } from './../common/text-input-control/text-input-control.component';
import { NgUploaderModule } from 'ngx-uploader';
import { MDBBootstrapModulesPro  } from 'ng-uikit-pro-standard';
import { BaseControl } from './../common/base-control';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PreloaderComponent } from '../common/preloader/preloader.component';
import { MultiTextInputControlComponent } from './../common/multi-text-input-control/multi-text-input-control.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { ScrollEventModule } from 'ngx-scroll-event';
import { ActionButtonComponent } from './../common/action-button/action-button.component';
import { LearningCenterService } from '../learning-center.service';
import { SafetyReportsService } from '../safety-reports/safety-reports.service';
import { QRCodeModule } from 'angularx-qrcode';

import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { FroalaEditorComponent } from '../common/froala-editor/froala-editor.component';
import { GetValuesPipe, GetDatePipe, GetDateTimePipe, GetDateIsoPipe, MinutesToSecondsPipe, GetHoursMinutesPipe } from '../common/common-types';

import { CheckboxControlComponent } from '../common/checkbox-control/checkbox-control.component';
import { SortablejsModule } from 'ngx-sortablejs';
import { MultipleSelectControlComponent } from '../common/multiple-select-control/multiple-select-control.component';
import { MultipleChoiceControlComponent } from '../common/multiple-choice-control/multiple-choice-control.component';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { PrintService } from '../common/print.service';
import { UserNameFromIdPipe, UserAavatarFromIdPipe, UserEmailFromIdPipe } from '../common/pipes/user-profile.pipe';
import { ParseFilenamePipe, GetDescriptionPipe, SafePipe, GetModuleNameFromIdPipe, GetMemoCategoryFromIdPipe, GetMemoPriorityFromIdPipe, GetRoleFromIdPipe, getLearningCenterNameFromIdPipe, HtmlToPlaintextPipe } from '../common/pipes/text-filter.pipe';
import {TranslatePipe} from '../common/pipes/translate.pipe'
import {cleanTranslatePipe} from '../common/pipes/clean-translate.pipe'
import {translateDatePipe} from '../common/pipes/translate-date.pipe'
import {TypeaheadPipe} from '../common/pipes/typeahead.pipe'
import {ConvertFileSizePipe} from '../common/pipes/filesize.pipe'
import {GetFileExtensionPipe} from '../common/pipes/fileextension.pipe'
import { FormErrorsControlComponent } from '../common/form-errors-control/form-errors-control.component';
import { TranslationService } from '../common/translation.service';
import { DatePickerControlComponent } from '../common/date-picker-control/date-picker-control.component';
import { TimePickerControlComponent } from '../common/time-picker-control/time-picker-control.component';
import { HelpService } from '../help/help.service';
import { CookieService } from 'ngx-cookie-service';
import { ConfirmationWindowControlComponent } from '../common/confirmation-window-control/confirmation-window-control.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BreadcrumbComponent } from '../common/breadcrumb/breadcrumb.component';
import { AlertMessageComponent } from '../common/alert-message/alert-message.component';

import { SimpleModalComponent } from '../common/modal/simple-modal/simple-modal.component';
import { ManageItemListComponent } from '../common/manage-item-list/manage-item-list.component';
import {FocusDirective} from "../common/directives/focus.directive";

import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/image_tui.min';
import { DeveloperComponent } from '../home/developer/developer.component';
import { ApiClientComponent } from '../home/developer/api-client/api-client.component';
import { SearchableSelectModule } from '../common/searchable-select/searchable-select.module';
import { ImageUploadComponent } from '../common/image-upload/image-upload.component';
import { HelpInfoComponent } from '../common/help-info/help-info.component';
import { ListingModule } from './listing/listing.module';
import { PptxPlayerComponent } from '../common/pptx-player/pptx-player.component';

library.add(fas, far, fal);

@NgModule({
  imports: [
    CommonModule,
    NgUploaderModule,
    FormsModule,
    ReactiveFormsModule,
    MDBBootstrapModulesPro.forRoot(),
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    SortablejsModule.forRoot({}),
    ColorPickerModule,
    ScrollEventModule,
    FontAwesomeModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    ScrollingModule,
    QRCodeModule,
    ListingModule,
    SearchableSelectModule
  ],
  declarations: [
    ConfirmationWindowControlComponent,
    FileUploadComponent,
    SwitchControlComponent,
    TextInputControlComponent,
    DatePickerControlComponent,
    TimePickerControlComponent,
    SimpleModalComponent,
    BaseControl,
    PreloaderComponent,
    MultiTextInputControlComponent,
    ActionButtonComponent,
    AlertMessageComponent,
    FroalaEditorComponent,
    GetValuesPipe,
    GetDateTimePipe,
    GetDatePipe,
    GetDateIsoPipe,
    MinutesToSecondsPipe,
    GetHoursMinutesPipe,
    SafePipe,
    HtmlToPlaintextPipe,
    GetModuleNameFromIdPipe,
    CheckboxControlComponent,
    MultipleSelectControlComponent,
    MultipleChoiceControlComponent,
    UserNameFromIdPipe,
    UserEmailFromIdPipe,
    UserAavatarFromIdPipe,
    ParseFilenamePipe,
    GetRoleFromIdPipe,
    TypeaheadPipe,
    TranslatePipe,
    cleanTranslatePipe,
    translateDatePipe,
    ConvertFileSizePipe,
    GetFileExtensionPipe,
    GetDescriptionPipe,
    getLearningCenterNameFromIdPipe,
    GetMemoCategoryFromIdPipe,
    GetMemoPriorityFromIdPipe,
    FormErrorsControlComponent,
    BreadcrumbComponent,
    ManageItemListComponent,
    FocusDirective,
    DeveloperComponent,
    ApiClientComponent,
    ImageUploadComponent,
    HelpInfoComponent,
    PptxPlayerComponent

  ],
  exports: [
    ListingModule,
    ConfirmationWindowControlComponent,
    FileUploadComponent,
    SwitchControlComponent,
    TextInputControlComponent,
    DatePickerControlComponent,
    TimePickerControlComponent,
    SimpleModalComponent,
    PreloaderComponent,
    FroalaEditorComponent,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MultiTextInputControlComponent,
    ColorPickerModule,
    ScrollEventModule,
    ActionButtonComponent,
    AlertMessageComponent,
    GetValuesPipe,
    GetDateTimePipe,
    GetHoursMinutesPipe,
    GetFileExtensionPipe,
    GetDatePipe,
    GetDateIsoPipe,
    MinutesToSecondsPipe,
    SafePipe,
    HtmlToPlaintextPipe,
    CheckboxControlComponent,
    GetModuleNameFromIdPipe,
    MultipleSelectControlComponent,
    MultipleChoiceControlComponent,
    MDBBootstrapModulesPro,
    FontAwesomeModule,
    UserNameFromIdPipe,
    UserEmailFromIdPipe,
    UserAavatarFromIdPipe,
    ParseFilenamePipe,
    GetRoleFromIdPipe,
    TypeaheadPipe,
    TranslatePipe,
    cleanTranslatePipe,
    translateDatePipe,
    GetDescriptionPipe,
    GetMemoCategoryFromIdPipe,
    GetMemoPriorityFromIdPipe,
    getLearningCenterNameFromIdPipe,
    FormErrorsControlComponent,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    ScrollingModule,
    BreadcrumbComponent,
    ManageItemListComponent,
    ConvertFileSizePipe,
    FocusDirective,
    QRCodeModule,
    DeveloperComponent, 
    ApiClientComponent,
    SearchableSelectModule,
    ImageUploadComponent,
    HelpInfoComponent,
    PptxPlayerComponent
  ],
  providers: [
    LearningCenterService,
    SafetyReportsService,
    PrintService,
    TranslationService,
    HelpService,
    CookieService
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    }
  }

  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, fal, far);
  }
}
